module.exports = {};
module.exports.storage = {
  // Domain for cookie storage
  domain: '.staging.spotii.me',
};

module.exports.oauth = {
  client_id: 'spotii-test',
  client_secret: '62YwVVaAMbFtfb3TmnnYaxHGrH7t4E3u',
  // Base64(`${client_id}.${client_secret}`)
  authorizationBasic: 'c3BvdGlpLXRlc3Q6NjJZd1ZWYUFNYkZ0ZmIzVG1ubllheEhHckg3dDRFM3U=',
  storageKey: 'spotii-auth:spotii-test:token',
  baseUrl: 'https://auth.staging.spotii.me',
  endpoints: {
    authorize: '/oauth2/auth',
    token: '/oauth2/token',
    consent: '/consent',
    revoke: '/oauth2/revoke',
    logout: '/oauth2/sessions/logout',
    login: '/api/v1.0/user/signin/',
    loginWithToken: '/api/v1.0/user/token/signin/',
  },
};

module.exports.verification = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    verifyWithEmailCode: '/verification/email_verification_tokens/',
    verifyWithPhoneCode: '/verification/phone_verification_tokens/{id}/verify/',
  },
};

module.exports.profile = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    profile: '',
    setNewPasswordRequest: '',
    setNewPasswordConfirm: '',
    setNewEmailRequest: '',
    setNewEmailConfirm: '',
    setNewEmailVerify: '',
    emailVerification: '',
  },
};

module.exports.registration = {
  baseUrl: 'https://auth.staging.spotii.me/api/v1.0',
  endpoints: {
    create: '',
    update: '',
    validate: '',
    verify: '',
    finalizeAndSignIn: '',
  },
};
